package com.jingfangpai.api.clients

import com.jingfangpai.common.data.response.ApiResponse
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromString
import com.jingfangpai.common.coroutines.applicationDispatcher
import kotlinx.coroutines.launch
import io.ktor.http.*
import io.ktor.client.plugins.*
import io.ktor.client.request.*
import com.jingfangpai.common.json.json
import kotlin.js.JsName
import io.ktor.content.TextContent
import io.ktor.client.call.body
import com.jingfangpai.api.base.BaseServiceClient
import kotlin.String
import com.jingfangpai.medicalRecord.model.MedicalRecordRawData

object DiagnosisApiClient :BaseServiceClient() {

	@JsName("generateDiagnosis")
	fun generateDiagnosis(medicalRecordId:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.medicalRecord.model.MedicalRecordDiagnosisSuggestionDto>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"medicalRecordId" to "${medicalRecordId?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.medicalRecord.model.MedicalRecordDiagnosisSuggestionDto>> = httpClient.get {
				    url("/api/diagnosis/generate?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getMedicalRecordAndDiagnosis")
	fun getMedicalRecordAndDiagnosis(medicalRecordId:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.medicalRecord.model.MedicalRecordAndDiagnosis>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"medicalRecordId" to "${medicalRecordId?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.medicalRecord.model.MedicalRecordAndDiagnosis> = httpClient.get {
				    url("/api/diagnosis/getMedicalRecordAndDiagnosis?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getNextDiagnosisItem")
	fun getNextDiagnosisItem(medicalRecordRawData:com.jingfangpai.medicalRecord.model.MedicalRecordRawData, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.smartTcm.model.DiagnosisQuestionAndAnswerItem>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.smartTcm.model.DiagnosisQuestionAndAnswerItem>> = httpClient.post {
				    url("/api/diagnosis/getNextDiagnosisItem?$params")
				    setBody(TextContent(json.encodeToString(com.jingfangpai.medicalRecord.model.MedicalRecordRawData.serializer(),medicalRecordRawData), io.ktor.http.ContentType.Application.Json))
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getRelatedDiagnosisItemsBasedonData")
	fun getRelatedDiagnosisItemsBasedonData(medicalRecordRawData:com.jingfangpai.medicalRecord.model.MedicalRecordRawData, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.smartTcm.model.DiagnosisQuestionAndAnswerItem>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.smartTcm.model.DiagnosisQuestionAndAnswerItem>> = httpClient.post {
				    url("/api/diagnosis/getRelatedDiagnosisItemsBasedonData?$params")
				    setBody(TextContent(json.encodeToString(com.jingfangpai.medicalRecord.model.MedicalRecordRawData.serializer(),medicalRecordRawData), io.ktor.http.ContentType.Application.Json))
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getRelatedDiagnosisItemsForMedicalRecord")
	fun getRelatedDiagnosisItemsForMedicalRecord(medicalRecordId:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.smartTcm.model.DiagnosisQuestionAndAnswerItem>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"medicalRecordId" to "${medicalRecordId?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.smartTcm.model.DiagnosisQuestionAndAnswerItem>> = httpClient.post {
				    url("/api/diagnosis/getRelatedDiagnosisItemsForMedicalRecord?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}

}
